import React, { useEffect } from 'react'
import { Bounce, toast } from 'react-toastify'

function loadScript(src: string): Promise<boolean> {
  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = () => {
      resolve(true)
    }
    script.onerror = () => {
      resolve(false)
    }
    document.body.appendChild(script)
  })
}

interface RazorpayProps {
  payload: any
  // headers: Record<string, string>
  // transactionStatusCallback: any
  // clientSecret: string
  // order: any
  callAfterPayment: any
}

export default function Razorpay(props: RazorpayProps): JSX.Element {
  const { payload, callAfterPayment } = props
  const { amount, currency, providerOrderId, config,clientId } = payload

  useEffect(() => {
    showRazorpay()
  }, [])

  async function showRazorpay() {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')
    if (!res) {
      toast.error('Razorpay SDK failed to load. Are you online?', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        transition: Bounce,
      })
      // alert("Razorpay SDK failed to load. Are you online?");
      return
    }

    const options = {
      key: clientId,
      currency: currency,
      amount: amount,
      order_id: providerOrderId,
      name: 'Payment',
      config: config,
      description: 'Order Summary, Below is your price breakup',
      handler: function (response:any) {
    // console.log({options})
        // console.log({response})
        console.log('success===',JSON.stringify(response))
        let data={
          id:response?.razorpay_payment_id,
          status:true
        }
        callAfterPayment(data)
      },
      modal: {
        ondismiss: function (response:any) {
        console.log('failed===',JSON.stringify(response))

          let data={
            id:response?.razorpay_payment_id||'',
            status:false
          }
          callAfterPayment(data)
        },
      },
    }
    console.log({options})


    const paymentObject = new (window as any).Razorpay(options)
    paymentObject.on('payment.failed', function () {})

    paymentObject.open()
  }

  return <div></div>
}
